<template>
  <DialogDefault v-bind="props">
    <DialogUiConfirm
      :cancel="cancel"
      :button-cancel="buttonCancel"
      :button-confirm="buttonConfirm"
      @confirm="emit('confirm')"
      @cancel="emit('cancel')"
    />
  </DialogDefault>
</template>
<script lang="ts" setup>
interface Props {
  title: string;
  label: string;
  labelHtml?: string;
  cancel?: boolean;
  buttonCancel?: string;
  buttonConfirm?: string;
  closeTimer?: number | null;
  iconHeader?: string;
}
const props = defineProps({
  title: null,
  label: null,
  labelHtml: null,
  cancel: { type: Boolean },
  buttonCancel: null,
  buttonConfirm: null,
  closeTimer: null,
  iconHeader: null
});
const emit = defineEmits(["cancel", "confirm"]);
</script>
